import * as React from "react";

interface CloseIconProps extends React.SVGProps<SVGSVGElement> {
  height?: number;
  width?: number;
  border?: boolean;
  color?: string;
}

function SvgComponent({
  height = 24,
  width = 24,
  border = false,
  color = "#E7212B",
}: CloseIconProps) {
  const containerSize = border ? height + 8 : height;

  return (
    <div
      style={{
        cursor: "pointer",
        width: containerSize * 1.3,
        height: containerSize * 1.3,
        border: border ? "1px solid #DADFE3" : "none",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: border ? "4px" : "0",
      }}
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_40000621_27714)">
          <path
            d="M15 5L5 15"
            stroke={color}
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 5L15 15"
            stroke={color}
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_40000621_27714">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default SvgComponent;
